import React, { useState } from 'react';

interface Step {
    title: string;
    description: string;
}

interface ServiceStepsProps {
    title: string;
    steps: Step[];
    color: string;
    ctaText?: string;
    onCtaClick?: () => void;
    tallyUrl?: string; // 👈 nouvelle prop optionnelle
}

const ServiceSteps: React.FC<ServiceStepsProps> = ({
                                                       title,
                                                       steps,
                                                       color,
                                                       ctaText,
                                                       onCtaClick,
                                                       tallyUrl
                                                   }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleCtaClick = () => {
        if (tallyUrl) {
            openModal();
        }
        if (onCtaClick) {
            onCtaClick();
        }
    };

    return (
        <section>
            <h2 className="text-2xl font-bold mb-8">{title}</h2>
            <div className="bg-white rounded-2xl shadow-lg p-8">
                <ol className="space-y-6">
                    {steps.map((step, index) => (
                        <li key={index} className="flex items-start">
              <span
                  className="w-8 h-8 rounded-full flex items-center justify-center mr-4 flex-shrink-0"
                  style={{ backgroundColor: `${color}15`, color }}
              >
                {index + 1}
              </span>
                            <div>
                                <h3 className="font-semibold mb-2">{step.title}</h3>
                                <p className="text-gray-600">{step.description}</p>
                            </div>
                        </li>
                    ))}
                </ol>

                {ctaText && (
                    <div className="mt-8 text-center">
                        <button
                            onClick={handleCtaClick}
                            className="px-8 py-3 rounded-lg text-white transition-colors hover:opacity-90"
                            style={{ backgroundColor: color }}
                        >
                            {ctaText}
                        </button>
                    </div>
                )}
            </div>

            {/* Modal */}
            {isModalOpen && tallyUrl && (
                <div
                    className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
                    onClick={closeModal}
                >
                    <div
                        className="bg-white rounded-2xl shadow-xl max-w-3xl w-full mx-4 relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center p-4 border-b">
                            <h3 className="text-lg font-semibold">Formulaire de préinscription</h3>
                            <button
                                onClick={closeModal}
                                className="text-gray-500 hover:text-gray-700 text-sm font-medium"
                            >
                                ✕ Fermer
                            </button>
                        </div>
                        <iframe
                            src={tallyUrl}
                            width="100%"
                            height="600"
                            frameBorder="0"
                            className="rounded-b-2xl"
                            title="Formulaire Tally"
                        />
                    </div>
                </div>
            )}
        </section>
    );
};

export default ServiceSteps;
